/**
 * Auflösung "welche Cart-Lines wurden gerade hinzugefügt?" für
 * addToCartSuccess-Payloads. Liefert [{ cartItem, quantity, requestItem }];
 * nur cartItem trägt die numerische product_id, im FormData steht bloß die
 * Variant-ID.
 *
 * Ursprünglich privat in tracking.js, extrahiert für den zweiten Consumer
 * sales-agent-events.js (MNR-777). Muss VOR tracking.js eingebunden werden.
 */
(function () {
  function normalizeCartAddResponse(cartData) {
    if (!cartData) return [];

    if (Array.isArray(cartData.items)) {
      return cartData.items;
    }

    if (cartData.id && cartData.variant_id) {
      return [cartData];
    }

    return [];
  }

  function parseProductFormItems(formData) {
    const itemsByIndex = new Map();

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^items\[(\d+)\]\[(.+)\]$/);
      if (!match) continue;

      const index = Number(match[1]);
      const field = match[2];

      let item = itemsByIndex.get(index);
      if (!item) {
        item = { properties: {} };
        itemsByIndex.set(index, item);
      }

      if (field === 'id') {
        item.id = String(value);
      } else if (field === 'quantity') {
        item.quantity = Number(value);
      } else if (field === 'parent_id') {
        item.parent_id = String(value);
      } else if (field.startsWith('properties][')) {
        const propName = field.slice('properties]['.length);
        item.properties[propName] = String(value);
      }
    }

    let items = Array.from(itemsByIndex.values());

    if (!items.length) {
      const singleId = formData.get('id');
      if (singleId) {
        items = [
          {
            id: String(singleId),
            quantity: Number(formData.get('quantity') || 1),
            properties: {},
          },
        ];
      }
    }

    return items;
  }

  function matchRequestedItemsToCart(requestItems, cartData) {
    if (!Array.isArray(requestItems) || !requestItems.length || !cartData) {
      return [];
    }

    const cartItems = normalizeCartAddResponse(cartData);
    const result = [];

    for (const req of requestItems) {
      if (!req.id) continue;

      const line = cartItems.find((ci) => String(ci.variant_id) === String(req.id));

      if (!line) continue;

      let quantity;

      if (typeof req.quantity === 'number' && !Number.isNaN(req.quantity)) {
        // tracke nie mehr als tatsächlich in der Line gelandet ist
        quantity = Math.min(req.quantity, line.quantity);
      } else {
        quantity = line.quantity;
      }

      result.push({
        cartItem: line,
        quantity,
        requestItem: req,
      });
    }

    return result;
  }

  function getAddedLinesFromPayload(e) {
    let requestItems = [];

    // Weg A: Product Form
    if (e.source === 'product-form' && e.formData) {
      requestItems = parseProductFormItems(e.formData);
    }

    // Weg B: Gifts / direkte Adds
    if (!requestItems.length && Array.isArray(e.requestItems)) {
      requestItems = e.requestItems;
    }

    if (requestItems.length) {
      return matchRequestedItemsToCart(requestItems, e.cartData);
    }

    // Fallback: wir haben keine Requests, versuchen es direkt mit cartData
    // ACHTUNG: liefert ALLE Cart-Lines, nicht nur die neu hinzugefügten (z. B.
    // sections/octane-atc.liquid publisht ohne formData und ohne requestItems).
    // Consumer, die genau eine Line brauchen, müssen solche Payloads ablehnen —
    // siehe assets/sales-agent-events.js.
    const cartItems = normalizeCartAddResponse(e.cartData);
    return cartItems.map((ci) => ({
      cartItem: ci,
      quantity: ci.quantity,
      requestItem: null,
    }));
  }

  window.MNRCartLines = {
    getAddedLinesFromPayload: getAddedLinesFromPayload,
    normalizeCartAddResponse: normalizeCartAddResponse,
    parseProductFormItems: parseProductFormItems,
    matchRequestedItemsToCart: matchRequestedItemsToCart,
  };
})();
